import './connectionLost.scss'
import templateUrl from './connectionLost.html'

/**
 * Route Connection lost.
 *
 * @namespace routes.ConnectionLost
 * @type {TmrRoute}
 */
export const route = {
  name: 'errorConnectionLost',
  label: 'CONNECTIONLOST.TITLE',
  component: 'tmrConnectionLost',
  accessControl: [],
  accessAnonymous: true,
}

/**
 * Component for the Connection lost route.
 *
 * @type {ngComponent}
 */
export const tmrConnectionLost = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrConnectionLostController',
}

/**
 * Controller of component {@link tmrConnectionLost}.
 *
 * @type {ngController}
 */
export class tmrConnectionLostController {
  static ngType = 'controller'

  constructor(
    $http,
    $state,
    $stateParams,
    $timeout,
    TmrConnectionTimeoutError,
    TmrApi
  ) {
    'ngInject'
    Object.assign(this, {
      $http,
      $state,
      $stateParams,
      $timeout,
      TmrConnectionTimeoutError,
      ping: TmrApi.endpoint('ping'),
    })
  }

  $onInit() {
    this.$http.get(this.ping).catch(err => {
      if (err instanceof this.TmrConnectionTimeoutError)
        this.$timeout(() => this.$onInit(), 1000)
      else this.$state.go(this.$stateParams.prevState ?? 'app')
    })
  }
}
